/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * PopulateEMR
 * OpenAPI spec version: v1
 */

export type EMRTypes = typeof EMRTypes[keyof typeof EMRTypes];


export const EMRTypes = {
  Populate: 'Populate',
  ModMed: 'ModMed',
} as const;
